<template>
  <div>
    <el-dialog custom-class="editor-dialog" :center="center" :close-on-click-modal="closeOnClickModal" :width="width" :visible="dialogVisible" top="8vh"
      :z-index="2000" :before-close="handleClose" @open="onDialogOpen">
      <template #title>
        <span>{{`${model.Id > 0 ? "编辑" : "添加"}合同`}}</span>
      </template>
      <div class="backgroud-white cs-editor-content">
        <el-form key="form" v-ref="(com, key) => $vueRefStore.setChildrenRef(key, com)" :rules="rules" :model="model" label-width="100px">
          <el-form-item label="合同名称" prop="Name">
            <el-input placeholder="请输入课程名称" :disabled="readonly" v-model="model.Name" class="input-width" />
          </el-form-item>
          <el-form-item label="合同类型" prop="ContractType">
            <el-select :disabled="readonly || contractTypeDisabled" v-model="model.ContractType" placeholder="请选择合同类型" class="input-width">
              <el-option v-for="item in contractTypeOptions" :key="item.value" :label="item.desc" :value="item.value" />
            </el-select>
          </el-form-item>
          <el-form-item label="状态" prop="Enable">
            <el-select :disabled="readonly" v-model="model.Enable" placeholder="请选择状态" class="input-width">
              <el-option label="启用" :value="true" />
              <el-option label="禁用" :value="false" />
            </el-select>
          </el-form-item>
          <el-form-item label="合同描述" prop="Description">
            <el-input type="textarea" :autosize="{minRows: 3, maxRows: 5}" placeholder="请输入合同描述" :disabled="readonly" v-model="model.Description"
              class="input-width" />
          </el-form-item>
          <el-form-item label="合同文件" prop="Files">
            <el-row>
              <el-col v-for="(item, index) in model.Files" :key="index">
                <a href="javascript:;" @click="downloadContractFile(item.FileStorageId)">
                  <span>{{item.FileStorageName}}</span>
                </a>
                <el-button v-if="!readonly" type="text" size="medium" @click="onRemoveFileClick(index)">删除</el-button>

              </el-col>
            </el-row>
            <el-button v-if="!readonly" size="medium" type="primary" plain @click="openBlobUploader">本地上传</el-button>
          </el-form-item>
        </el-form>
      </div>
      <template #footer>
        <div class="dialog-footer popup-footer">
          <el-row>
            <el-col>
              <el-button :disabled="readonly || isSaving" :loading="isSaving" type="primary" @click="saveChanges">确认</el-button>
            </el-col>
          </el-row>
        </div>
      </template>
    </el-dialog>
    <el-dialog center title="上传合同文件" :show-close="true" :close-on-click-modal="false" width="700px" :visible.sync="blobUploaderVisible" top="8vh"
      :z-index="3000">
      <blob-uploader @closeEditor="closeBlobUploader" @blobUploadError="onBlobUploaderUploadError" @blobUploaded="onBlobUploaderUploaded" :type="13"
        :accepts="'.pdf'" :isVisible="blobUploaderVisible" :isAutoSave="true"></blob-uploader>
    </el-dialog>
  </div>
</template>

<script>
import { saveContract } from "@/service/contract.service";
import { removeFileStorage } from "@/service/blobStorage.service";
import {
  getBlobFileUrlById,
  downloadFileToBlob,
} from "@/service/blobStorage.service";
import { downloadFile } from "@/config/mUtils";

const mixinGeneralMethods = {
  methods: {
    validate() {
      let isValid = true;

      let refForm = this.$vueRefStore.getChildrenRef("form");
      if (!!refForm) {
        refForm.validate((valid) => {
          isValid = valid;
        });
      }

      return isValid;
    },
  },
};

const default_dataModel = {
  Id: 0,
  Enable: true,
  Name: null,
  Description: null,
  ContractType: null,
  Files: [],
};

export default {
  name: "contractEditor",
  mixins: [mixinGeneralMethods],
  components: {
    blobUploader: () => import("@/components/fileHandler/blobUploader"),
  },
  props: {
    center: {
      type: Boolean,
      default: true,
    },
    closeOnClickModal: {
      type: Boolean,
      default: false,
    },
    width: {
      type: String,
      default: "35%",
    },
    visible: {
      type: Boolean,
      default: false,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    data: {
      type: Object,
      default: () => {
        return Object.clone(default_dataModel);
      },
    },
  },
  model: {
    prop: "visible",
    event: "visibleChange",
  },
  data() {
    return {
      isSaving: false,
      dialogVisible: false,
      rules: {
        Name: [
          {
            required: true,
            message: "请输入合同名称",
            trigger: "blur",
          },
          {
            max: 250,
            message: "合同名称不可超过250个字符",
            trigger: "blur",
          },
        ],
        ContractType: [
          {
            required: true,
            message: "请选择合同类型",
            trigger: "blur",
          },
        ],
        Enable: [
          {
            required: true,
            message: "请选择状态",
            trigger: "blur",
          },
        ],
      },
      model: Object.clone(default_dataModel),
      blobUploaderVisible: false,
      contractTypeDisabled: false,
      contractTypeOptions:[]
    };
  },
  created() {
    let options = this.GLOBAL.contractType.getOptions();
 
    if (!this.USERMANAGER.isVocationalTrainingManager){
      options = options.filter(i => i.value !== 0);
    }else{
      options = options.filter(i => i.value === this.GLOBAL.contractType.vocationalTraining);
      default_dataModel.ContractType = this.GLOBAL.contractType.vocationalTraining;
      this.contractTypeDisabled = true;
    }
    this.contractTypeOptions = options;
    this.reloadVisible();
  },
  methods: {
    // 和服务端进行数据交互相关方法
    async saveContractToServer() {
      this.isSaving = true;
      let data = Object.clone(this.model);

      try {
        let result = await saveContract(data);
        if (!!result && result.success) {
          this.model.Id = result.data;

          this.$message({
            message: "保存成功",
            type: "success",
          });

          this.$emit("change", this.model);
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.isSaving = false;
      }
    },
    async removeFileStorageToServer(id, isDelete = false) {
      try {
        let result = await removeFileStorage(id, isDelete);

        return !!result && result.success && result.data;
      } catch (error) {
        console.error(error);
        return false;
      }
    },

    reloadVisible(newValue = this.visible) {
      if (this.dialogVisible === newValue) return;

      this.dialogVisible = newValue;
      if (this.dialogVisible) this.reloadDataFromProps();
    },
    resetData() {
      this.model = Object.clone(default_dataModel);
    },
    reloadDataFromProps() {
      if (!this.dialogVisible) return;

      this.model = Object.clone(this.data || default_dataModel);
      let refForm = this.$vueRefStore.getChildrenRef("form");
      if (!!refForm) {
        refForm.resetFields();
      }
    },
    showDialog() {
      this.dialogVisible = true;
      this.$emit("visibleChange", this.dialogVisible);
    },
    async closeDialog() {
      this.dialogVisible = false;
      this.$emit("visibleChange", this.dialogVisible);
    },
    onDialogOpen() {
      this.reloadDataFromProps();
    },
    handleClose(done) {
      this.$nextTick(async () => {
        if (this.model.Files.length > 0) {
          for (let i = this.model.Files.length - 1; i >= 0; i--) {
            await this.removeFile(i);
          }
        }
        this.resetData();

        this.closeDialog();
      });
    },
    saveChanges() {
      let isValid = this.validate();
      if (!isValid) return;

      this.$nextTick(async () => {
        await this.saveContractToServer();
        this.closeDialog();
      });
    },
    openBlobUploader() {
      this.blobUploaderVisible = true;
    },
    closeBlobUploader() {
      this.blobUploaderVisible = false;
    },
    onBlobUploaderUploadError() {},
    onBlobUploaderUploaded(data) {
      this.$nextTick(async () => {
        if (Object.typeOf(data) === "array") {
          data.forEach((item) => {
            this.model.Files = [];
            this.model.Files.push({
              Id: 0,
              FileStorageId: item.FileId,
              FileStorageName: item.FileName,
              FileStoragePath: item.Path,
            });
          });
        } else {
          this.model.Files = [];
          this.model.Files.push({
            Id: 0,
            FileStorageId: data.FileId,
            FileStorageName: data.FileName,
            FileStoragePath: data.Path,
          });
        }

        this.closeBlobUploader();
      });
    },
    downloadContractFile(fileId) {
      getBlobFileUrlById(fileId)
        .then((result) => {
          if (!!result && result.success) {
            let { Url, FileName } = result.data;
            downloadFileToBlob(Url, 0).then((res) => {
              if (!!res && !!res.data)
                downloadFile({ data: res.data, filename: FileName });
              else this.$message.error("未能正确获取到文件数据。");
            });
          } else {
            if (!!result.message) {
              this.$message.error(result.message);
            }
          }
        })
        .catch(() => {});
    },
    async removeFile(index = 0) {
      if (this.model.Files.length <= index) return false;

      let file = this.model.Files[index];
      let result = true;

      if (!file.Id) {
        result = await this.removeFileStorageToServer(file.FileStorageId, true);
      }

      if (result) {
        this.model.Files.splice(index, 1);
      }

      return result;
    },
    onRemoveFileClick(index = 0) {
      this.$confirm("您确认要删除该文件吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          this.removeFile(index);
        })
        .catch(() => {});
    },
  },
  watch: {
    visible(newValue) {
      this.reloadVisible(newValue);
    },
  },
};
</script>

<style lang="scss" scoped>
.el-dialog__wrapper {
  /deep/ .editor-dialog {
    min-width: 400px;

    .el-dialog__header {
      font-size: 1.75em;
      font-weight: bold;
    }
  }
}

.cs-editor-content {
  padding: 0 15%;
  overflow-y: auto;

  .el-form-item {
    margin-bottom: 12px;

    .input-width {
      width: 100%;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/contract/contractEditor.vue